import React from "react";
import { useAuth } from "@/context/AuthContext";
import CoachDepot from "@/components/documentdepot/CoachDepot";
import MemberDepot from "@/components/documentdepot/MemberDepot";

export default function DocumentDepot() {
  const { user } = useAuth();
  const role = user?.role;
  if (role === "coach") return <CoachDepot />;
  if (role === "team_member") return <MemberDepot />;
  return (
    <div className="mx-auto max-w-md py-20 text-center" data-testid="depot-admin-info">
      <h2 className="font-heading text-lg font-semibold text-slate-800">Document Depot</h2>
      <p className="mt-2 text-sm text-slate-500">The Document Depot is managed by each team's coach from their own Google Drive.</p>
    </div>
  );
}
